(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["a11y-custom-controls"] && !Shopify.designMode) return;
  try {
    (() => {
    const controlSelector = 'dropdown-opener, accordeon-button, carousel-button, list-btn';
    const spaceKeySelector = `${controlSelector}, button[data-column-switcher-item], button.product-thumbnail-carousel__thumb`;
    const cartDrawerSelector = 'cart-drawer#CartDrawer';
    const cartDrawerTriggerSelector = '[data-sidebar-id="CartDrawer"]';
    const focusableSelector = [
      'a[href]',
      'area[href]',
      'button:not([disabled])',
      'input:not([disabled]):not([type="hidden"])',
      'select:not([disabled])',
      'textarea:not([disabled])',
      'summary',
      '[contenteditable="true"]',
      '[role="button"]',
      '[tabindex]',
    ].join(',');
    const enhancedControls = new WeakSet();
    const enhancedSwitchers = new WeakSet();
    const enhancedProductGalleries = new WeakSet();
    const enhancedCartDrawers = new WeakSet();
    const inertBackground = new Map();
    let accordionPanelCount = 0;
    let activeCartDrawer = null;
    let cartDrawerIsOpen = false;
    let lastOutsideFocus = null;
    let pendingCartDrawerTrigger = null;

    const syncDropdown = (control) => {
      const controlledId = control.dataset.floatElementId;

      control.setAttribute('aria-expanded', control.dataset.ariaExpanded === 'true' ? 'true' : 'false');

      if (controlledId) {
        control.setAttribute('aria-controls', controlledId);
      }
    };

    const syncAccordion = (control) => {
      const component = control.closest('accordeon-component');

      if (!component) return;

      const panel = component.querySelector('[data-accordeon-content-wrap]');

      control.setAttribute('aria-expanded', component.dataset.ariaExpanded === 'true' ? 'true' : 'false');

      if (!panel) return;

      if (!panel.id) {
        accordionPanelCount += 1;
        panel.id = `A11yAccordionPanel-${accordionPanelCount}`;
      }

      control.setAttribute('aria-controls', panel.id);
    };

    const syncCarouselButton = (control) => {
      if (control.hasAttribute('disabled')) {
        control.setAttribute('aria-disabled', 'true');
        control.setAttribute('tabindex', '-1');
        return;
      }

      control.removeAttribute('aria-disabled');
      control.setAttribute('tabindex', '0');
    };

    const enhanceControl = (control) => {
      control.setAttribute('role', 'button');

      if (!control.hasAttribute('tabindex')) {
        control.setAttribute('tabindex', '0');
      }

      if (control.matches('dropdown-opener')) {
        syncDropdown(control);
      }

      if (control.matches('accordeon-button')) {
        syncAccordion(control);
      }

      if (control.matches('carousel-button')) {
        syncCarouselButton(control);
      }

      enhancedControls.add(control);
    };

    const syncColumnSwitcher = (switcher) => {
      switcher.querySelectorAll('[data-column-switcher-item]').forEach((item) => {
        item.setAttribute('aria-pressed', item.classList.contains('selected') ? 'true' : 'false');
      });
    };

    const enhanceColumnSwitcher = (switcher) => {
      syncColumnSwitcher(switcher);

      const switcherObserver = new MutationObserver(() => {
        syncColumnSwitcher(switcher);
      });

      switcherObserver.observe(switcher, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });

      enhancedSwitchers.add(switcher);
    };

    const syncProductGallery = (gallery) => {
      gallery.querySelectorAll('button.product-thumbnail-carousel__thumb').forEach((thumbnail) => {
        thumbnail.setAttribute('aria-current', thumbnail.classList.contains('is-primary') ? 'true' : 'false');
      });
    };

    const enhanceProductGallery = (gallery) => {
      syncProductGallery(gallery);

      const galleryObserver = new MutationObserver(() => {
        syncProductGallery(gallery);
      });

      galleryObserver.observe(gallery, {
        subtree: true,
        attributes: true,
        attributeFilter: ['class'],
      });

      enhancedProductGalleries.add(gallery);
    };

    const isVisible = (element) => {
      if (!(element instanceof HTMLElement)) return false;
      if (element.hidden || element.closest('[hidden], [inert], [aria-hidden="true"]')) return false;

      const styles = window.getComputedStyle(element);

      return styles.display !== 'none' && styles.visibility !== 'hidden' && element.getClientRects().length > 0;
    };

    const getFocusableElements = (container) => {
      return Array.from(container.querySelectorAll(focusableSelector)).filter((element) => {
        if (!(element instanceof HTMLElement)) return false;
        if (element.matches('[disabled], [aria-disabled="true"], [tabindex="-1"]')) return false;

        return isVisible(element);
      });
    };

    const hasOpenNestedModal = (drawer) => {
      const selector = [
        '[role="dialog"][aria-modal="true"].is-opened',
        'quick-view.is-opened',
        'search-sidebar.is-opened',
        'sidebar-component.is-opened',
      ].join(',');

      return Array.from(document.querySelectorAll(selector)).some((modal) => {
        return modal !== drawer && !drawer.contains(modal) && isVisible(modal);
      });
    };

    const shouldKeepBackgroundElementInteractive = (element, drawer) => {
      if (element.contains(drawer)) return true;
      if (element.matches('script, style, link, template')) return true;
      if (element.id === 'Portal' || element.querySelector('#Portal')) return true;
      if (element.querySelector('.body-overlay')) return true;
      if (element.matches('aside') && element.querySelector('quick-view')) return true;

      return false;
    };

    const applyCartDrawerInert = (drawer) => {
      Array.from(document.body.children).forEach((element) => {
        if (!(element instanceof HTMLElement)) return;

        if (!inertBackground.has(element)) {
          inertBackground.set(element, element.inert);
        }

        element.inert = !shouldKeepBackgroundElementInteractive(element, drawer);
      });
    };

    const restoreCartDrawerBackground = () => {
      inertBackground.forEach((wasInert, element) => {
        if (element.isConnected) {
          element.inert = wasInert;
        }
      });

      inertBackground.clear();
    };

    const focusCartDrawer = (drawer) => {
      window.requestAnimationFrame(() => {
        if (!cartDrawerIsOpen || activeCartDrawer !== drawer || !drawer.isConnected) return;
        if (drawer.contains(document.activeElement)) return;

        const preferredControl = drawer.querySelector('.cart-drawer__header-close-button-wrapper');
        const target = isVisible(preferredControl) ? preferredControl : getFocusableElements(drawer)[0];

        if (target instanceof HTMLElement) {
          target.focus();
        } else {
          drawer.focus();
        }
      });
    };

    const returnFocusFromCartDrawer = () => {
      const savedTrigger = pendingCartDrawerTrigger;
      pendingCartDrawerTrigger = null;

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const fallbackTrigger = document.querySelector(cartDrawerTriggerSelector);
          const target =
            savedTrigger instanceof HTMLElement && savedTrigger.isConnected && isVisible(savedTrigger)
              ? savedTrigger
              : fallbackTrigger;

          if (target instanceof HTMLElement && isVisible(target)) {
            target.focus();
          }
        });
      });
    };

    const openCartDrawer = (drawer) => {
      activeCartDrawer = drawer;
      cartDrawerIsOpen = true;

      if (
        !(pendingCartDrawerTrigger instanceof HTMLElement) ||
        !pendingCartDrawerTrigger.isConnected ||
        drawer.contains(pendingCartDrawerTrigger)
      ) {
        pendingCartDrawerTrigger =
          lastOutsideFocus instanceof HTMLElement && lastOutsideFocus.isConnected ? lastOutsideFocus : null;
      }

      applyCartDrawerInert(drawer);
      focusCartDrawer(drawer);
    };

    const closeCartDrawer = () => {
      if (!cartDrawerIsOpen) return;

      cartDrawerIsOpen = false;
      activeCartDrawer = null;
      restoreCartDrawerBackground();
      returnFocusFromCartDrawer();
    };

    const syncCartDrawer = (drawer) => {
      const isOpen = drawer.classList.contains('is-opened');

      if (isOpen && (!cartDrawerIsOpen || activeCartDrawer !== drawer)) {
        openCartDrawer(drawer);
        return;
      }

      if (!isOpen && cartDrawerIsOpen && activeCartDrawer === drawer) {
        closeCartDrawer();
      }
    };

    const enhanceCartDrawer = (drawer) => {
      const drawerObserver = new MutationObserver(() => {
        syncCartDrawer(drawer);
      });

      drawerObserver.observe(drawer, {
        attributes: true,
        attributeFilter: ['class'],
      });

      enhancedCartDrawers.add(drawer);
      syncCartDrawer(drawer);
    };

    const reconcileCartDrawer = () => {
      const currentDrawer = document.querySelector(cartDrawerSelector);

      if (currentDrawer instanceof HTMLElement && currentDrawer.classList.contains('is-opened')) {
        syncCartDrawer(currentDrawer);
        return;
      }

      if (cartDrawerIsOpen) {
        closeCartDrawer();
      }
    };

    const enhanceWithin = (root) => {
      if (root instanceof Element && root.matches(controlSelector) && !enhancedControls.has(root)) {
        enhanceControl(root);
      }

      if (root instanceof Element && root.matches('column-switcher') && !enhancedSwitchers.has(root)) {
        enhanceColumnSwitcher(root);
      }

      if (
        root instanceof Element &&
        root.matches('carousel-dots.product-thumbnail-carousel') &&
        !enhancedProductGalleries.has(root)
      ) {
        enhanceProductGallery(root);
      }

      if (root instanceof Element && root.matches(cartDrawerSelector) && !enhancedCartDrawers.has(root)) {
        enhanceCartDrawer(root);
      }

      if (!(root instanceof Document || root instanceof Element)) return;

      root.querySelectorAll(controlSelector).forEach((control) => {
        if (!enhancedControls.has(control)) {
          enhanceControl(control);
        }
      });

      root.querySelectorAll('column-switcher').forEach((switcher) => {
        if (!enhancedSwitchers.has(switcher)) {
          enhanceColumnSwitcher(switcher);
        }
      });

      root.querySelectorAll('carousel-dots.product-thumbnail-carousel').forEach((gallery) => {
        if (!enhancedProductGalleries.has(gallery)) {
          enhanceProductGallery(gallery);
        }
      });

      root.querySelectorAll(cartDrawerSelector).forEach((drawer) => {
        if (!enhancedCartDrawers.has(drawer)) {
          enhanceCartDrawer(drawer);
        }
      });
    };

    document.addEventListener(
      'focusin',
      (event) => {
        if (!(event.target instanceof HTMLElement)) return;
        if (cartDrawerIsOpen || event.target.closest(cartDrawerSelector)) return;

        lastOutsideFocus = event.target;
      },
      true
    );

    document.addEventListener(
      'pointerdown',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const interactiveTarget = event.target.closest(
          `${cartDrawerTriggerSelector}, button, a[href], input, select, textarea, [role="button"], [tabindex]`
        );

        if (!(interactiveTarget instanceof HTMLElement) || interactiveTarget.closest(cartDrawerSelector)) return;

        lastOutsideFocus = interactiveTarget;

        if (interactiveTarget.matches(cartDrawerTriggerSelector)) {
          pendingCartDrawerTrigger = interactiveTarget;
        }
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        if (!(event.target instanceof Element)) return;

        const trigger = event.target.closest(cartDrawerTriggerSelector);

        if (trigger instanceof HTMLElement && !trigger.closest(cartDrawerSelector)) {
          pendingCartDrawerTrigger = trigger;
        }
      },
      true
    );

    document.addEventListener(
      'keydown',
      (event) => {
        if (
          event.key === 'Tab' &&
          cartDrawerIsOpen &&
          activeCartDrawer instanceof HTMLElement &&
          !hasOpenNestedModal(activeCartDrawer)
        ) {
          const focusableElements = getFocusableElements(activeCartDrawer);

          if (focusableElements.length === 0) {
            event.preventDefault();
            event.stopImmediatePropagation();
            activeCartDrawer.focus();
            return;
          }

          const currentIndex = focusableElements.indexOf(document.activeElement);
          let nextIndex = event.shiftKey ? currentIndex - 1 : currentIndex + 1;

          if (currentIndex === -1) {
            nextIndex = event.shiftKey ? focusableElements.length - 1 : 0;
          } else if (nextIndex < 0) {
            nextIndex = focusableElements.length - 1;
          } else if (nextIndex >= focusableElements.length) {
            nextIndex = 0;
          }

          event.preventDefault();
          event.stopImmediatePropagation();
          focusableElements[nextIndex].focus();
          return;
        }

        if (event.key === 'Tab' && !event.shiftKey && event.target instanceof Element) {
          const accordionButton = event.target.closest('accordeon-button');
          const filterAccordion = accordionButton?.closest('accordeon-component.filters__accordeon');

          if (filterAccordion && accordionButton.getAttribute('aria-expanded') === 'true') {
            const firstFilterInput = Array.from(
              filterAccordion.querySelectorAll('.filters__options input:not([disabled])')
            ).find((input) => isVisible(input));

            if (firstFilterInput instanceof HTMLElement) {
              event.preventDefault();
              firstFilterInput.focus();
              return;
            }
          }
        }

        if (event.key !== ' ') return;
        if (!(event.target instanceof Element)) return;

        const control = event.target.closest(spaceKeySelector);

        if (!control || control.getAttribute('aria-disabled') === 'true') return;

        event.preventDefault();
        control.click();
      },
      true
    );

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'childList') {
          mutation.addedNodes.forEach((node) => {
            if (node instanceof Element) {
              enhanceWithin(node);
            }
          });

          if (cartDrawerIsOpen && activeCartDrawer instanceof HTMLElement) {
            applyCartDrawerInert(activeCartDrawer);
          }

          reconcileCartDrawer();
          return;
        }

        if (!(mutation.target instanceof Element)) return;

        if (mutation.target.matches('dropdown-opener')) {
          syncDropdown(mutation.target);
        }

        if (mutation.target.matches('accordeon-component')) {
          const control = mutation.target.querySelector('accordeon-button');

          if (control) {
            syncAccordion(control);
          }
        }

        if (mutation.target.matches('carousel-button')) {
          syncCarouselButton(mutation.target);
        }
      });
    });

    const init = () => {
      enhanceWithin(document);
      observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ['data-aria-expanded', 'disabled'],
      });
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init, { once: true });
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shipping-cutoff-engine"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.yfpShippingCutoffInitialized) {
      window.yfpUpdateShippingCutoffs?.();
      return;
    }

    window.yfpShippingCutoffInitialized = true;

    const berlinFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Berlin',
      weekday: 'short',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const translations = {
      active: 'Noch [time] — dann wird deine Bestellung heute verschickt',
      after: 'Heute bestellt — Versand am nächsten Werktag',
      weekend: 'Am Wochenende bestellt — Versand am nächsten Werktag'
    };

    const translationsElement = document.querySelector(
      '[data-shipping-cutoff-translations]'
    );

    if (translationsElement) {
      try {
        Object.assign(
          translations,
          JSON.parse(translationsElement.textContent)
        );
      } catch (error) {
        console.warn('Shipping cutoff translations could not be read.', error);
      }
    }

    const getBerlinTime = () =>
      Object.fromEntries(
        berlinFormatter
          .formatToParts(new Date())
          .map((part) => [part.type, part.value])
      );

    const formatDuration = (remainingSeconds) => {
      const locale = document.documentElement.lang || 'de-DE';
      const totalMinutes = Math.max(
        1,
        Math.ceil(remainingSeconds / 60)
      );
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      const parts = [];

      if (hours > 0) {
        parts.push(
          new Intl.NumberFormat(locale, {
            style: 'unit',
            unit: 'hour',
            unitDisplay: 'short'
          }).format(hours)
        );
      }

      parts.push(
        new Intl.NumberFormat(locale, {
          style: 'unit',
          unit: 'minute',
          unitDisplay: 'short'
        }).format(minutes)
      );

      return parts.join(' ');
    };

    const updateElement = (element, time) => {
      const weekdays = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri'];
      const isWeekday = weekdays.includes(time.weekday);

      const currentSeconds =
        Number(time.hour) * 3600 +
        Number(time.minute) * 60 +
        Number(time.second);

      const cutoffSeconds =
        Number(element.dataset.shippingCutoffHour || 14) * 3600 +
        Number(element.dataset.shippingCutoffMinute || 0) * 60;

      const remainingSeconds = cutoffSeconds - currentSeconds;
      const isActive = isWeekday && remainingSeconds > 0;
      const mode =
        element.dataset.shippingCutoffMode || 'message';

      const textElement = element.querySelector(
        '[data-shipping-cutoff-text]'
      );

    const setText = (text) => {
    if (textElement.textContent !== text) {
        textElement.textContent = text;
    }
    };

    const setActiveText = (template, duration) => {
    const token = '[time]';
    const tokenPosition = template.indexOf(token);

    if (tokenPosition === -1) {
        setText(template);
        return;
    }

    const completeText = template.replace(token, duration);

    if (textElement.textContent === completeText) {
        return;
    }

    const timeElement = document.createElement('strong');
    timeElement.className = 'shipping-cutoff__time';
    timeElement.textContent = duration;

    textElement.replaceChildren(
        document.createTextNode(template.slice(0, tokenPosition)),
        timeElement,
        document.createTextNode(
        template.slice(tokenPosition + token.length)
        )
    );
    };

      if (mode === 'progress' && !isActive) {
        element.hidden = true;
        return;
      }

      element.hidden = false;

      if (!isWeekday) {
        setText(
          element.dataset.shippingCutoffWeekend ||
          translations.weekend
        );
        return;
      }

      if (!isActive) {
        setText(
          element.dataset.shippingCutoffAfter ||
          translations.after
        );
        return;
      }

      const duration = formatDuration(remainingSeconds);

    setActiveText(
        element.dataset.shippingCutoffActive || translations.active,
        duration
        );

      if (mode === 'progress') {
        const progress = Math.max(
          0,
          Math.min(
            100,
            (remainingSeconds / cutoffSeconds) * 100
          )
        );

        const track = element.querySelector(
          '[data-shipping-cutoff-track]'
        );

        const fill = element.querySelector(
          '[data-shipping-cutoff-fill]'
        );

        track.setAttribute(
          'aria-valuenow',
          String(Math.round(progress))
        );

        fill.style.setProperty(
          '--shipping-cutoff-progress',
          String(progress / 100)
        );
      }
    };

    const updateAll = () => {
      const time = getBerlinTime();

      document
        .querySelectorAll('[data-shipping-cutoff]')
        .forEach((element) => {
          updateElement(element, time);
        });
    };

    window.yfpUpdateShippingCutoffs = updateAll;

    const start = () => {
      updateAll();

      window.setInterval(updateAll, 30000);

      new MutationObserver(updateAll).observe(
        document.body,
        {
          childList: true,
          subtree: true
        }
      );
    };

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        start,
        { once: true }
      );
    } else {
      start();
    }

    document.addEventListener(
      'shopify:section:load',
      updateAll
    );
  })();
  } catch(e) { console.error(e); }
})();

})();
